export const ALLOWED_PRODUCT_LOT_SIZES = [1, 5, 10, 15, 25, 30] as const;

export type ProductLotSize = (typeof ALLOWED_PRODUCT_LOT_SIZES)[number];

export const getDefaultLotSize = (price: number): number => {
  if (price <= 175) return 25;
  if (price > 175 && price < 1000) return 10;
  return 1;
};

export const getLotSize = (price: number, customLotSize?: number | null): number => {
  if (typeof customLotSize === 'number' && customLotSize > 0) {
    return customLotSize;
  }
  return getDefaultLotSize(price);
};

export const formatLotQuantity = (quantity: number, lotSize: number): string => {
  if (lotSize <= 1) return `x ${quantity}`;
  return `${quantity} lot${quantity > 1 ? 's' : ''} de ${lotSize}`;
};
